<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="docente" titulo="Docente / Personal"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-hidden-mobile menu-izquierda is-2">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside ></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <app-tabla-opciones [ctrl]="ctrl"></app-tabla-opciones>

            <span style="overflow-y:auto; overflow-x:hidden; display:block; height: 79vh;">

                <!--Tabla -->
                <table class="table is-striped is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando " style="overflow:auto;" >
                    <thead>
                        <tr>
                            <th><abbr>Nombre</abbr></th>
                            <th>Sexo</th>
                            <th>Estatus</th>
                            <th>CURP</th>
                            <th>Email</th>
                            <th>Telefono</th>
                            <th>Dirección</th>
                            <th *ngIf="permisos.indexOf('DocenteController.reiniciar') >-1">Cuenta</th>
                            <th width="1%">Opciones</th>
                        </tr>
                    </thead>
                    <!-- FALTA MODALIDAD -->
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index">
                            <th style="vertical-align: middle;">{{ item.nombre }} {{ item.apellido_paterno }} {{ item.apellido_materno }}</th>
                            <td style="vertical-align: middle;">{{ item.sexo }}</td>
                            <!-- <td style="vertical-align: middle;">{{ item.docentes_metadatos.fecha_nacimiento }}</td> -->
                            <td style="vertical-align: middle;font-size:24px;">
                                <span *ngIf="item.activo==1">
                                    <i class="fa fa-circle has-text-success" title="Activo"></i></span>
                                <span *ngIf="item.activo==0 ">
                                    <i class="fa fa-circle has-text-danger" title="No Activo"></i></span>

                                    <!-- <span *ngIf="item.activo== null">
                                        <i class="fa fa-circle has-text-warning" title="No Activo"></i></span> -->
                            </td>
                            <td style="vertical-align: middle;">{{ item.curp }}</td>
                            <td style="vertical-align: middle;">{{ item.email }}</td>
                            <td style="vertical-align: middle;">{{ item.docentes_metadatos.telefono_contacto }}</td>
                            <td style="vertical-align: middle;">Col: {{ item.docentes_metadatos.colonia }}, {{ item.docentes_metadatos.calle }} #int {{ item.docentes_metadatos.no_interior }} #ext {{ item.docentes_metadatos.no_exterior }}</td>
                            <td style="vertical-align: middle;"*ngIf="permisos.indexOf('DocenteController.reiniciar') >-1">
                                <a  class="navbar-item tooltip is-danger" (click)="reiniciar($event,item.id, 'reiniciar-conteo');">
                                    <span class="icon fa-2x has-text-danger">
                                        <i class="icon-close"></i>
                                    </span>
                                    <span class="tooltiptext">Reiniciar contraseña</span>
                                </a>
                            </td>
                            <td style="vertical-align: middle;" class="has-text-centered">
                                <!-- acciones -->
                                <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="8" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <!-- <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando">
                    <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
                        <article class="media">
                            <div class="media-left">
                            <figure class="image is-64x64">
                                <img [src]="item.foto ? ctrl.API_PATH+'/adjunto/personas/'+item.foto : item.avatar" alt="Image">
                            </figure>
                            </div>
                            <div class="media-content">
                                <div class="content">
                                    <p>
                                        <strong class="tag is-medium is-black">
                                            {{ item.docentes_metadatos.nombre }} {{ item.docentes_metadatos.apellido_paterno }} {{ item.docentes_metadatos.apellido_materno }}
                                        </strong>
                                        <strong class="tag is-medium is-primary">
                                            <i class="fa fa-calendar pad-right-10"></i> {{ item.docentes_metadatos.fecha_nacimiento }}
                                        </strong>
                                        <strong class="tag is-medium">
                                            Sexo: {{ item.docentes_metadatos.sexo }}
                                        </strong>
                                        <strong class="tag is-medium is-warning">
                                            {{ item.docentes_metadatos.curp }}
                                        </strong>
                                        <strong class="tag is-medium is-danger">
                                            <i class="fa fa-envelope pad-right-10"></i>  {{ item.docentes_metadatos.email }}
                                        </strong>
                                        <strong class="tag is-medium is-success">
                                                <i class="fa fa-globe pad-right-10"></i>{{ item.docentes_metadatos.colonia }}, {{ item.docentes_metadatos.calle }} #int {{ item.docentes_metadatos.no_interior }} #ext {{ item.docentes_metadatos.no_exterior }}
                                        </strong>
                                    </p>


                                </div>
                                <nav class="level is-mobile" style="float:right">
                                    <div class="level-left">

                                        <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                                    </div>
                                </nav>
                            </div>
                        </article>
                    </div>
                </span> -->
            </span>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>

        </div>
    </div>
</div>


<div class="modal" id="reiniciar-conteo">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title"><i class="fa fa-warning"></i> Confirmación</p>
            <button class="delete" (click)="cancelarFiltros('reiniciar-conteo')"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Está seguro que desea reiniciar contraseña del docente?</h1>
                <p>Ya no se podra recuperar la información</p>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="reincia_conteo(item)"
                [ngClass]="{'is-loading': borrarCargando}">Continuar</a>
            <a class="button" (click)="cancelarFiltros('reiniciar-conteo')">Cancelar</a>
        </footer>
    </div>
</div>